import { SortableFilter } from '../../common/sortable-filter';

export class MediaListFilter extends SortableFilter {
    public group: string = null;
}
